import React, { FC } from 'react'

import { Dot, DotWrapper, Wrapper } from './CarouselDots.styles'

type Props =  {
  amount: number
  current: number
  onClick: (index: number) => void
}

export const CarouselDots: FC<Props> = ({ amount, current, onClick }) => (
  <Wrapper>
    {[...Array(amount)].map((_, index) => (
      <DotWrapper key={index} onClick={() => onClick(index)}>
        <Dot isActive={index === current} />
      </DotWrapper>
    ))}
  </Wrapper>
)
